export default "__VITE_ASSET__MSJTgDxP__"